import { CooperateType } from '../../tools/public'
import { GetLocalStorage, RoleTypeParam } from '../../tools/util'

// action 类型定义
export const TOKEN_ACTION_TYPE = {
  SET_DATA: 'TOKEN/SET_DATA', // 设置数据
  DEL_DATA: 'TOKEN/DEL_DATA', // 清除数据
  ADD_TABS: 'TOKEN/ADD_TABS', // 设置tabs数据
  DEL_TABS: 'TOKEN/DEL_TABS', // 删除tabs数据
  CHECK_TABS: 'TOKEN/CHECK_TABS', // 选中tabs数据
  RESET_TABS: 'TOKEN/RESET_TABS', // 重置tabs数据
  DEL_OTHER: 'TOKEN/DEL_OTHER',
  UPDATE_TAB_SEARCH: 'TOKEN/UPDATE_TAB_SEARCH', // 更新tab的search参数
  SET_CURRENT_RIGHT_TAB: 'TOKEN/SET_CURRENT_RIGHT_TAB',
}
export interface tabsParam {
  title: string
  key: string
  keyName: string // 唯一 key
  url: string
  search: string
}
// 当前状态接口
export interface tokenState {
  sub: string // 用户名
  orgName: string // 员工所属组织名
  role?: RoleTypeParam // 角色名
  empCode: string // 员工编码
  created: string // 创建时间
  orgCode: string // 员工所属组织编码
  empName: string // 员工名
  exp: string // token过期时间
  userId: string // 用户id
  resources: string[] // 角色所拥有的资源
  cooperateType: CooperateType
}
interface State extends tokenState {
  tabsData: tabsParam[] // tabs数据
  tabsActive: string // 高亮的tabs
  authRouter: string[] // 路由鉴权
  currentRightTab?: tabsParam // 当前右键操作的tab
}
// 默认数据
const defaultState: State = {
  sub: '',
  orgName: '',
  role: undefined,
  empCode: '',
  created: '',
  orgCode: '',
  empName: '',
  exp: '',
  resources: [],
  cooperateType: GetLocalStorage('COOPERATETYPE') ?? '3',
  tabsData: [],
  authRouter: [],
  userId: 'root',
  tabsActive: '',
  currentRightTab: undefined,
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  let arr = { ...state }
  switch (action.type) {
    case TOKEN_ACTION_TYPE.SET_DATA:
      arr.sub = action.value.sub
      arr.orgName = action.value.orgName
      arr.role = action.value.role
      arr.empCode = action.value.empCode
      arr.created = action.value.created
      arr.orgCode = action.value.orgCode
      arr.empName = action.value.empName
      arr.exp = action.value.exp
      arr.userId = action.value.userId
      arr.resources = action.value.resources
      arr.cooperateType = action.value.cooperateType
      return arr
    case TOKEN_ACTION_TYPE.DEL_DATA:
      arr = {
        sub: '',
        orgName: '',
        role: undefined,
        empCode: '',
        created: '',
        orgCode: '',
        empName: '',
        exp: '',
        resources: [],
        cooperateType: '3',
        tabsActive: '',
        userId: 'root',
        tabsData: [],
        authRouter: [],
      }
      return arr
    case TOKEN_ACTION_TYPE.ADD_TABS:
      arr.tabsData = [...arr.tabsData, ...[action.value]]
      return arr
    case TOKEN_ACTION_TYPE.DEL_TABS:
      arr.tabsData = arr.tabsData.filter((item) => item.key !== action.value)
      return arr
    case TOKEN_ACTION_TYPE.CHECK_TABS:
      arr.tabsActive = action.value
      return arr
    case TOKEN_ACTION_TYPE.RESET_TABS:
      arr.tabsData = []
      arr.tabsActive = ''
      return arr
    case TOKEN_ACTION_TYPE.DEL_OTHER:
      arr.tabsData = arr.tabsData.filter((item) => {
        return item.key === action.value
      })
      return arr
    case TOKEN_ACTION_TYPE.UPDATE_TAB_SEARCH:
      arr.tabsData = arr.tabsData.map((item) =>
        item.key === action.value.key
          ? { ...item, search: action.value.search }
          : item,
      )
      return arr
    case TOKEN_ACTION_TYPE.SET_CURRENT_RIGHT_TAB:
      arr.currentRightTab = action.value
      return arr
    default:
      return state
  }
}

// Action Creators
export const setAuthtokenAction = (e: tokenState) => ({
  type: TOKEN_ACTION_TYPE.SET_DATA,
  value: e,
})
export const delAuthtokenAction = () => ({
  type: TOKEN_ACTION_TYPE.DEL_DATA,
})

// 设置tabs
export const addTabsAction = (e: tabsParam) => ({
  type: TOKEN_ACTION_TYPE.ADD_TABS,
  value: e,
})

// 删除 tabs 注意key
export const delTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.DEL_TABS,
  value: e,
})

// 删除 tabs 注意key
export const delOtherTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.DEL_OTHER,
  value: e,
})
// 选中tabs 高亮
export const checkTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.CHECK_TABS,
  value: e,
})

// 重置 tabs 数据
export const resetTabsAction = () => ({
  type: TOKEN_ACTION_TYPE.RESET_TABS,
})

// 更新 tab 的 search 参数(同详情页打开了另一张单据时)
export const updateTabSearchAction = (e: { key: string; search: string }) => ({
  type: TOKEN_ACTION_TYPE.UPDATE_TAB_SEARCH,
  value: e,
})

export const setCurrentRightTabAction = (e?: tabsParam) => ({
  type: TOKEN_ACTION_TYPE.SET_CURRENT_RIGHT_TAB,
  value: e,
})
import { CooperateType } from '../../tools/public'
import { GetLocalStorage, RoleTypeParam } from '../../tools/util'

// action 类型定义
export const TOKEN_ACTION_TYPE = {
  SET_DATA: 'TOKEN/SET_DATA', // 设置数据
  DEL_DATA: 'TOKEN/DEL_DATA', // 清除数据
  ADD_TABS: 'TOKEN/ADD_TABS', // 设置tabs数据
  DEL_TABS: 'TOKEN/DEL_TABS', // 删除tabs数据
  CHECK_TABS: 'TOKEN/CHECK_TABS', // 选中tabs数据
  RESET_TABS: 'TOKEN/RESET_TABS', // 重置tabs数据
  DEL_OTHER: 'TOKEN/DEL_OTHER',
  UPDATE_TAB_SEARCH: 'TOKEN/UPDATE_TAB_SEARCH', // 更新tab的search参数
  SET_CURRENT_RIGHT_TAB: 'TOKEN/SET_CURRENT_RIGHT_TAB',
}
export interface tabsParam {
  title: string
  key: string
  keyName: string // 唯一 key
  url: string
  search: string
}
// 当前状态接口
export interface tokenState {
  sub: string // 用户名
  orgName: string // 员工所属组织名
  role?: RoleTypeParam // 角色名
  empCode: string // 员工编码
  created: string // 创建时间
  orgCode: string // 员工所属组织编码
  empName: string // 员工名
  exp: string // token过期时间
  userId: string // 用户id
  resources: string[] // 角色所拥有的资源
  cooperateType: CooperateType
}
interface State extends tokenState {
  tabsData: tabsParam[] // tabs数据
  tabsActive: string // 高亮的tabs
  authRouter: string[] // 路由鉴权
  currentRightTab?: tabsParam // 当前右键操作的tab
}
// 默认数据
const defaultState: State = {
  sub: '',
  orgName: '',
  role: undefined,
  empCode: '',
  created: '',
  orgCode: '',
  empName: '',
  exp: '',
  resources: [],
  cooperateType: GetLocalStorage('COOPERATETYPE') ?? '3',
  tabsData: [],
  authRouter: [],
  userId: 'root',
  tabsActive: '',
  currentRightTab: undefined,
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  let arr = { ...state }
  switch (action.type) {
    case TOKEN_ACTION_TYPE.SET_DATA:
      arr.sub = action.value.sub
      arr.orgName = action.value.orgName
      arr.role = action.value.role
      arr.empCode = action.value.empCode
      arr.created = action.value.created
      arr.orgCode = action.value.orgCode
      arr.empName = action.value.empName
      arr.exp = action.value.exp
      arr.userId = action.value.userId
      arr.resources = action.value.resources
      arr.cooperateType = action.value.cooperateType
      return arr
    case TOKEN_ACTION_TYPE.DEL_DATA:
      arr = {
        sub: '',
        orgName: '',
        role: undefined,
        empCode: '',
        created: '',
        orgCode: '',
        empName: '',
        exp: '',
        resources: [],
        cooperateType: '3',
        tabsActive: '',
        userId: 'root',
        tabsData: [],
        authRouter: [],
      }
      return arr
    case TOKEN_ACTION_TYPE.ADD_TABS:
      arr.tabsData = [...arr.tabsData, ...[action.value]]
      return arr
    case TOKEN_ACTION_TYPE.DEL_TABS:
      arr.tabsData = arr.tabsData.filter((item) => item.key !== action.value)
      return arr
    case TOKEN_ACTION_TYPE.CHECK_TABS:
      arr.tabsActive = action.value
      return arr
    case TOKEN_ACTION_TYPE.RESET_TABS:
      arr.tabsData = []
      arr.tabsActive = ''
      return arr
    case TOKEN_ACTION_TYPE.DEL_OTHER:
      arr.tabsData = arr.tabsData.filter((item) => {
        return item.key === action.value
      })
      return arr
    case TOKEN_ACTION_TYPE.UPDATE_TAB_SEARCH:
      arr.tabsData = arr.tabsData.map((item) =>
        item.key === action.value.key
          ? { ...item, search: action.value.search }
          : item,
      )
      return arr
    case TOKEN_ACTION_TYPE.SET_CURRENT_RIGHT_TAB:
      arr.currentRightTab = action.value
      return arr
    default:
      return state
  }
}

// Action Creators
export const setAuthtokenAction = (e: tokenState) => ({
  type: TOKEN_ACTION_TYPE.SET_DATA,
  value: e,
})
export const delAuthtokenAction = () => ({
  type: TOKEN_ACTION_TYPE.DEL_DATA,
})

// 设置tabs
export const addTabsAction = (e: tabsParam) => ({
  type: TOKEN_ACTION_TYPE.ADD_TABS,
  value: e,
})

// 删除 tabs 注意key
export const delTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.DEL_TABS,
  value: e,
})

// 删除 tabs 注意key
export const delOtherTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.DEL_OTHER,
  value: e,
})
// 选中tabs 高亮
export const checkTabsAction = (e: string) => ({
  type: TOKEN_ACTION_TYPE.CHECK_TABS,
  value: e,
})

// 重置 tabs 数据
export const resetTabsAction = () => ({
  type: TOKEN_ACTION_TYPE.RESET_TABS,
})

// 更新 tab 的 search 参数(同详情页打开了另一张单据时)
export const updateTabSearchAction = (e: { key: string; search: string }) => ({
  type: TOKEN_ACTION_TYPE.UPDATE_TAB_SEARCH,
  value: e,
})

export const setCurrentRightTabAction = (e?: tabsParam) => ({
  type: TOKEN_ACTION_TYPE.SET_CURRENT_RIGHT_TAB,
  value: e,
})
